<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-lines
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-list-ul mr-2'></i> Líneas de contenido</h4>"
          v-else
        ></table-lines>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableLines from "./TableLines";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "partners",
  components: {
    TableLines,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        {key:"acciones",label:"Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getLines();
  },
  methods: {
    getLines() {
      var lines = store.getters.getLines;
      if (lines.length == 0) {
        this.isLoading = true;
        store.dispatch("getLines").then(() => {
          lines = store.getters.getLines;
          shuffleArray([lines]);
          this.isLoading = false;
          this.items = lines;
          this.itemsArray = lines;
        });
      } else {
        shuffleArray([lines]);
        this.items = lines;
        this.itemsArray = lines;
      }
    }
  }
};
</script>
